import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  InAppNotification,
  NotificationChannelPreferences,
} from '@kinet-open-network/shared/data-access/model';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  protected http = inject(HttpClient);

  getNotifications() {
    return this.http
      .get<{ data: InAppNotification[] }>('/notifications')
      .pipe(map((response) => response.data));
  }

  getNotificationsUnreadCount() {
    return this.http
      .get<{ data: number }>('/notifications/unread-count')
      .pipe(map((response) => response.data));
  }

  markNotificationAsRead(notification: InAppNotification) {
    return this.http
      .post<{
        data: InAppNotification;
      }>(
        `/notifications/${notification.type}/${notification.id}/mark-as-read`,
        {},
      )
      .pipe(map((response) => response.data));
  }

  getNotificationOptions() {
    return this.http
      .get<{ data: NotificationChannelPreferences }>('/notifications/options')
      .pipe(map((response) => response.data));
  }

  updateNotificationOptions(preferences: NotificationChannelPreferences) {
    return this.http
      .put<{ data: NotificationChannelPreferences }>('/notifications/options', {
        preferences,
      })
      .pipe(map((response) => response.data));
  }
}
